//Created by wangshuyi on 07/03/2018.

'use strict';

let auth = function (code) {
    let flag = false;
    let authArea = this.$store.state.auth || this.$store.state.userInfo.auth;
    if(authArea){
        flag = !!authArea.find(item => item.CONTROL_NAME === code);
    }
    return flag;
};

export default auth;
